/* ─────────────────────────────────────────────────────────────────────────
   Sense page — ONLY the borewell devices that carry a water-sense (HydroSense),
   rendered with the existing PumpStatusV3 card (shows Wet/Dry inline).
   ──────────────────────────────────────────────────────────────────────── */
import React from "react";
import { useHistory } from "react-router-dom";
import { BiPulse } from "react-icons/bi";
import PumpStatusV3 from "../sensor/PumpStatusV3";
import SplashScreen from "../utils/SplashScreen";
import { useSensorList, useSenseBorewells } from "./dashV3.data";
import {
  PageContainer, ContentContainer, OuterBox, SensorType, DeviceGroup,
  PageHeader, BackBtn, HeaderTitle, HeaderCount, Msg,
} from "./dashV3.styles";

export default function SensePageV3() {
  const history = useHistory();
  const { loading, borewells } = useSensorList();
  const { loading: senseLoading, list: sense } = useSenseBorewells(borewells, !loading);

  if (loading || senseLoading) return <SplashScreen />;

  return (
    <PageContainer>
      <PageHeader>
        <BackBtn onClick={() => history.push("/")}>←</BackBtn>
        <BiPulse size={20} color="#237A35" />
        <HeaderTitle>Sense</HeaderTitle>
        <HeaderCount>{sense.length} devices</HeaderCount>
      </PageHeader>

      <ContentContainer>
        <OuterBox>
          <SensorType>Water Sense</SensorType>
          {sense.length === 0 ? (
            <Msg>No water-sense devices.</Msg>
          ) : (
            <DeviceGroup>
              {sense.map((b) => (
                <PumpStatusV3 key={b.motor_id} motor_id={b.motor_id} sensor_id={b.sensor_id} isBorewell={true} />
              ))}
            </DeviceGroup>
          )}
        </OuterBox>
      </ContentContainer>
    </PageContainer>
  );
}
